import Vue from "vue";
import Vuetify from "vuetify/lib";
import "material-design-icons-iconfont/dist/material-design-icons.css";
Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "md",
  },
  theme: {
    themes: {
      light: {
        primary: "#0c57d2",
        secondary: "#2769d7",
      },
      dark: {
        primary: "#0c57d2",
        secondary: "#2769d7",
      },
    },
  },
});
